import React from "react";
import Cousin from "./Cousin/Cousin";

const Aunty = () => {
  return (
    <div>
      <h4>Aunty</h4>
      <section className="flex">
        <Cousin></Cousin>
        <Cousin></Cousin>
      </section>
    </div>
  );
};

export default Aunty;
